export default {
    filterTrackers(
        trackers,
        {
            search,
            filterByBattery,
            filterByColor,
            filterByInactive,
            filterByLeftZone,
            filterByLocation,
            filterByType,
            filterByAlert,
            filterByRecentlyActive,
            lastActiveFor,
        }
    ) {
        if (!trackers?.length) {
            return trackers
        }

        let result = trackers

        if (search) {
            const searchQuery = search.toLowerCase()
            result = result.filter(
                tracker =>
                    tracker.asset_details.name
                        .toLowerCase()
                        .includes(searchQuery) ||
                    tracker.deveui.toLowerCase().includes(searchQuery) ||
                    tracker.asset_details?.identification
                        ?.toLowerCase()
                        .includes(searchQuery)
            )
        }
        if (filterByBattery) {
            result = result.filter(
                asset =>
                    asset.asset_details.sensor_data.battery?.low ||
                    asset.asset_details.sensor_data.battery_status?.value ===
                        'critical'
            )
        }
        if (filterByLeftZone) {
            result = result.filter(
                asset => asset.last_gps_measurement?.is_outside
            )
        }
        if (filterByInactive) {
            result = result.filter(asset => !asset.active)
        }
        if (filterByAlert) {
            result = result.filter(asset => asset.asset_details.alert)
        }
        if (filterByRecentlyActive) {
            let now = new Date()
            result = result.filter(
                tracker =>
                    now - new Date(tracker.last_message_timestamp) <
                    lastActiveFor
            )
        }
        if (filterByType?.length) {
            result = result.filter(tracker =>
                filterByType.includes(tracker.asset_details.asset_type)
            )
        }
        if (filterByLocation?.length) {
            result = result.filter(tracker =>
                filterByLocation.includes(tracker.location)
            )
        }
        if (filterByColor?.length) {
            result = result.filter(tracker =>
                filterByColor.includes(tracker.asset_details.color)
            )
        }
        return result
    },
}
